import styled from 'styled-components';

export const TitleType = styled.span`
  margin: 0;
  font-size: 13px;
  font-weight: bold;
  white-space: nowrap;
`;

export const ContainerHeaderGrid = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-right: 10px;
`;

